import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './style.scss';
import { Props } from './typing';
import ProfileFooter from '../ProfileFooter';
import { getMerchantDetailsFromStore } from '../../../../../../lib/helper';
import { Col, Row } from 'antd';
import {
  kycFormSubmitAction,
  verifyKYCAction,
  kycFormReSubmitAction,
  updateAccountAction,
  kycFormSubmitClear,
} from '../../../../../../redux/actions/completeProfile';
import { clearSalesforceAuth, salesforceAuth } from '../../../../../../redux/actions/signup';
import {
  location,
  product,
  keyValueMap,
  BankDetailsTemplate,
  valueKeyMap,
  entityTypeMap,
  togglePath,
} from './constants';
import InputField from '../../../../../../components/TextInput';
import SelectDropdown from '../../../../../../components/Select';
import { Upload } from 'antd';
import Button from '../../../../../../components/Button';
import { convertFileToBase64 } from '../../../../../../lib/helper';
import imgURL from '../../../../../../lib/imgURL';
import notify from '../../../../../../lib/notifiy';
import Modal from '../../../../../../screens/Products/Plural/Login/components/Modal';
import useRedirect from '../../../../../../hooks/useRedirect';
import { setCurrentRoute } from '../../../../../../lib/localStorage';
import { UiRoutes } from '../../../../../../lib/constants';

const UploadDocuments: FC<Props> = (props): JSX.Element => {
  const {
    updateProfileDetails,
    nextPage,
    prevPage,
    currentStep,
    setCurrentStep,
    merchantProfile,
    verifyKYCAction,
    uploadDocState,
    submitForm2,
    salesforceAuth,
    salesforceState,
    kycFormSubmitAction,
    kycSubmitState,
    kycReSubmitState,
    kycFormReSubmitAction,
    updateAccountAction,
    loginState,
    kycFormSubmitClear,
    clearSalesforceAuth,
  } = props;

  const { push, path } = useRedirect();
  const [enableSave, setEnableSave] = useState(false);
  const [enableSaveNext, setEnableSaveNext] = useState(false);
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [errDesc, setErrDesc] = useState('');

  const { entityType, merchantPan } = getMerchantDetailsFromStore();
  const [kycdocs, setKycdocs] = useState<any>(
    { ...merchantProfile?.uploadDocuments } || {}
  );

  const [kycUpdates, setKycUpdates] = useState<any>({});

  const updateDocName = (key, kycdoc, type, value, fileData?) => {
    const tempdoc = JSON.parse(JSON.stringify(kycdocs));
    if (tempdoc[key][kycdoc].anyOneOf.includes(value)) {
      if (type === 'file' && fileData) {
        tempdoc[key][kycdoc].fileData = fileData;
      } else {
        tempdoc[key][kycdoc].documentSubType = value;
        delete tempdoc[key][kycdoc].fileData;
      }
    }
    setKycdocs(tempdoc);
  };

  const removeDoc = (key, kycdoc, value) => {
    const tempdoc = JSON.parse(JSON.stringify(kycdocs));
    if (tempdoc[key][kycdoc].anyOneOf.includes(value)) {
      delete tempdoc[key][kycdoc].fileData;
    }
    setKycdocs(tempdoc);
  };

  const checkIfFilesSaved = () => {
    let savedFiles = false;
    let filesSaved = 0;
    if (kycdocs && Object.keys(kycdocs) && Object.keys(kycdocs).length > 0) {
      Object.keys(kycdocs).forEach((docCat) => {
        Object.keys(kycdocs[docCat]).forEach((docType) => {
          if (kycdocs[docCat][docType].fileData) {
            filesSaved++;
          }
        });
      });
    } else {
      savedFiles = true;
    }

    if (filesSaved > 0) {
      savedFiles = false;
    }

    return savedFiles;
  };

  useEffect(() => {
    if (checkIfFilesSaved() || merchantProfile?.kycProfile) {
      const payload = {
        merchantPAN: merchantProfile.merchantDetails.pan || merchantPan,
        location: location,
        product: product,
        merchantType: entityTypeMap[entityType],
      };

      verifyKYCAction(payload);
    }
    return () => {
      clearSalesforceAuth();
    };
  }, []);

  const callFormSubmit = (step, statusData) => {
    const merchantProfileValue = {
      ...merchantProfile,
      uploadDocuments: kycdocs,
    };
    updateProfileDetails(step, statusData, merchantProfileValue);
  };

  useEffect(() => {
    const { isSuccess, data } = uploadDocState;
    if (merchantProfile?.kycProfile) {
      const tempprofiles = merchantProfile?.kycProfile?.document.map((item) => {
        const selectedCategory = data?.kycCategories?.filter(
          (val) => val.kycCategory === valueKeyMap[item.docType]
        );
        const filteredAnyOf = selectedCategory?.length
          ? selectedCategory[0].documents?.filter((val) =>
              val.anyOneOf.includes(valueKeyMap[item.docuSubType])
            )
          : [];
        item.anyOneOf = filteredAnyOf?.length
          ? filteredAnyOf[0].anyOneOf
          : [item.docuSubType];
        return item;
      });
      setKycUpdates(tempprofiles);
    } else {
      if (isSuccess && data) {
        if (data?.kycCategories?.length) {
          let document = {};
          document = [...data?.kycCategories, BankDetailsTemplate]?.reduce(
            (acc, item) => {
              return {
                ...acc,
                [item.kycCategory]: item.documents.reduce(
                  (accChild, docitem, i) => {
                    return {
                      ...accChild,
                      ['document' + i]: {
                        ...docitem,
                        documentSubType: docitem.anyOneOf[0],
                      },
                    };
                  },
                  {}
                ),
              };
            },
            {}
          );
          setKycdocs(document);
        }
      }
    }
  }, [uploadDocState]);

  const submitForm2Action = () => {
    salesforceAuth();
  };

  useEffect(() => {
    if (salesforceState.isSuccess && salesforceState.access_token) {
      if (merchantProfile?.kycSubmitted && merchantProfile?.kycProfile) {
        const resubmitPayload = {
          pluralKYCDocument: {
            pluralKYCInfo: {
              kycCaseId: merchantProfile?.kycProfile?.caseId,
              uatMID: merchantProfile?.kycProfile?.UATMID,
              virtualStoreId: merchantProfile?.kycProfile?.virtualStoreID,
              documents: kycUpdates
                ?.filter((item) => item?.status?.toLowerCase() === 'failed')
                .map((item) => {
                  return {
                    Title: item?.fileData?.name,
                    VersionData: item?.fileData?.data,
                    DocumentType: item?.docType,
                    DocumentSubType: item?.docuSubType,
                  };
                }),
            },
          },
        };
        kycFormReSubmitAction(resubmitPayload, {
          access_token: salesforceState.access_token || '',
          instance_url: salesforceState.instance_url || '',
          token_type: salesforceState.token_type || '',
        });
      } else {
        const merchantProfileValue = {
          ...merchantProfile,
          uploadDocuments: kycdocs,
        };
        const form2payload = submitForm2(merchantProfileValue);
        kycFormSubmitAction(form2payload, {
          access_token: salesforceState.access_token || '',
          instance_url: salesforceState.instance_url || '',
          token_type: salesforceState.token_type || '',
        });
      }
    }

    if (salesforceState.isFailure) {
      notify({
        message: 'Error fetching the SF Token.',
        type: 'error',
        description: salesforceState.error_message || '',
      });
    }
  }, [salesforceState.isSuccess, salesforceState.isFailure]);

  useEffect(() => {
    const { isSuccess, isFailure, data, errorMessage } = kycSubmitState;

    if (isSuccess && data) {
      // Update the VirtualStoreId in Plural
      if (data.AccountID && loginState.MerchantId) {
        updateAccountAction({
          merchantId: loginState.MerchantId,
          virtualStoreId: data.AccountID,
        });
      }
      const merchantProfileValue = {
        ...merchantProfile,
        kycSubmitted: true,
      };
      updateProfileDetails(
        currentStep,
        {
          saved: true,
          completed: true,
        },
        merchantProfileValue
      );
      if (path !== togglePath) {
        setCurrentRoute(path);
      }
      setTimeout(() => {push(UiRoutes.TOGGLEENV);},1000);
    }

    if (isFailure && errorMessage) {
      const reason: string|undefined = errorMessage?.fault[0]?.errorMessage || '';
      setErrDesc(`${errorMessage?.message}. ${reason}` ?? '');
      setIsErrorModal(true);
    }
  }, [kycSubmitState]);

  useEffect(() => {
    const { isSuccess, isFailure, data, errorMessage } = kycReSubmitState;

    if (isSuccess && data) {
      const merchantProfileValue = {
        ...merchantProfile,
        kycReSubmitted: true,
      };
      updateProfileDetails(
        currentStep,
        {
          saved: true,
          completed: true,
        },
        merchantProfileValue
      );
    }

    if (isFailure && errorMessage) {
      setErrDesc(errorMessage?.message ?? '');
      setIsErrorModal(true);
    }
  }, [kycReSubmitState]);

  useEffect(() => {
    try {
      if (JSON.stringify(kycdocs).indexOf('fileData') > -1) {
        setEnableSave(true);
      } else {
        setEnableSave(false);
      }
    } catch (e) {
      setEnableSave(false);
    }
    let savenext = true;
    Object.keys(kycdocs).forEach((docCat) => {
      Object.keys(kycdocs[docCat]).forEach((docType) => {
        if (!kycdocs[docCat][docType].fileData) {
          savenext = false;
        }
      });
    });
    setEnableSaveNext(savenext);
  }, [kycdocs]);

  return (
    <form>
      {kycUpdates?.length > 0 ? (
        <>
          <div className='kyc-upload-products'>
            <div className='title'>Upload Documents</div>

            {kycUpdates?.map((item, i) => {
              return (
                <div className='kyc-detail-container' key={i}>
                  <div className='kyc-details'>
                    <div className='kyc-title'>{item.docType}</div>
                    <div className='kyc-content'></div>
                  </div>
                  <div className='doc-row'>
                    {item?.status?.toLowerCase() !== 'failed' ? (
                      <Row>
                        <Col span={10}>
                          <div className='approved-message'>
                            <img src={imgURL['approved-icon']} alt='approved' />
                            <div className='approved-text'>{`${item?.docType} has been verified successfully !!!`}</div>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col span={6}>
                          {item?.anyOneOf?.length > 1 ? (
                            <>
                              <SelectDropdown
                                wrapperClass='form-control'
                                value={keyValueMap[item?.docSubType]}
                                onChange={(value) => {
                                  const tempdoclist = JSON.parse(
                                    JSON.stringify(kycUpdates)
                                  );
                                  tempdoclist.forEach((doc) => {
                                    if (doc.docType === item.docType) {
                                      doc.docSubType = value;
                                    }
                                  });
                                  setKycUpdates(tempdoclist);
                                }}
                                optionList={item?.anyOneOf.map((val) => ({
                                  label: val,
                                  value: val,
                                }))}
                              />
                            </>
                          ) : (
                            <>
                              <InputField
                                type='text'
                                value={item?.anyOneOf[0]}
                                className='form-control upload-type'
                                readonly={true}
                                handleChange={() => {}}
                              />
                            </>
                          )}
                        </Col>
                        <Col span={4} offset={1}>
                          {item.fileData ? (
                            <>
                              <div className='file-details'>
                                <div className='file-name'>
                                  {item.fileData.name}
                                </div>
                                <img
                                  className='remove-file'
                                  onClick={() => {
                                    const tempdoclist = JSON.parse(
                                      JSON.stringify(kycUpdates)
                                    );
                                    tempdoclist.forEach((doc) => {
                                      if (
                                        doc.docType === item.docType &&
                                        doc.docSubType === item.docSubType
                                      ) {
                                        delete doc.fileData;
                                      }
                                    });
                                    setKycUpdates(tempdoclist);
                                  }}
                                  src={imgURL['cross-circle']}
                                  alt='close'
                                />
                              </div>
                            </>
                          ) : (
                            <>
                              <Upload
                                beforeUpload={() => {
                                  return false;
                                }}
                                multiple={false}
                                accept='image/png, image/jpeg, pdf'
                                onChange={async ({ file }) => {
                                  const fileData = await convertFileToBase64(
                                    file
                                  );
                                  const tempdoclist = JSON.parse(
                                    JSON.stringify(kycUpdates)
                                  );
                                  tempdoclist.forEach((doc) => {
                                    if (
                                      doc.docType === item.docType &&
                                      doc.docuSubType === item.docuSubType
                                    ) {
                                      doc.fileData = fileData;
                                    }
                                  });
                                  setKycUpdates(tempdoclist);
                                }}
                              >
                                <Button
                                  enable={true}
                                  label='Upload'
                                  btnStyleClass='secondary-button upload-action'
                                />
                              </Upload>
                            </>
                          )}
                        </Col>
                        <Col span={9} offset={1}>
                          <div className='rejection-message'>
                            {`${item.RejectionReason}. ${item.Solution}`}
                          </div>
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              );
            })}
            <div className='profile-footer'>
              <div className='profile-footer-action'>
                <Button
                  btnStyleClass='primary-button save-continue-action'
                  label='Submit'
                  btnIcon={
                    <img className='back-icon' src={imgURL['left-arrow']} />
                  }
                  btnIconPosition='right'
                  onClick={submitForm2Action}
                  enable={true}
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='kyc-upload-products'>
            <div className='title'>Upload Documents</div>

            <Row>
              <Col span={10}>
                <div className='content-text'></div>
              </Col>
            </Row>
            {Object.keys(kycdocs).length > 0 &&
              Object.keys(kycdocs).map((key, i) => {
                return (
                  <div className='kyc-detail-container' key={i}>
                    <div className='kyc-details'>
                      <div className='kyc-title'>{keyValueMap[key] || key}</div>
                      <div className='kyc-content'></div>
                    </div>
                    <div className='kyc-file-details'>
                      {Object.keys(kycdocs[key]).length > 0 &&
                        Object.keys(kycdocs[key])?.map((kycdoc, index) => {
                          const localdoctemp = kycdocs[key][kycdoc];
                          return (
                            <div key={index} className='doc-row'>
                              {localdoctemp.status.toLowerCase() ===
                              'success' ? (
                                <Row>
                                  <Col span={8}>
                                    <div className='approved-message'>
                                      <img
                                        src={imgURL['approved-icon']}
                                        alt='approved'
                                      />
                                      <div className='approved-text'>{`${
                                        keyValueMap[key] || key
                                      } has already been verified`}</div>
                                    </div>
                                  </Col>
                                </Row>
                              ) : (
                                <Row>
                                  <Col span={6}>
                                    {localdoctemp?.anyOneOf?.length > 1 ? (
                                      <>
                                        <SelectDropdown
                                          wrapperClass='form-control'
                                          value={
                                            keyValueMap[
                                              localdoctemp?.documentSubType
                                            ]
                                          }
                                          onChange={(value) => {
                                            updateDocName(
                                              key,
                                              kycdoc,
                                              'type',
                                              value
                                            );
                                          }}
                                          optionList={localdoctemp?.anyOneOf.map(
                                            (val) => ({
                                              label: keyValueMap[val] || val,
                                              value: val,
                                            })
                                          )}
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <InputField
                                          type='text'
                                          value={
                                            keyValueMap[
                                              localdoctemp?.anyOneOf[0]
                                            ]
                                          }
                                          className='form-control upload-type'
                                          readonly={true}
                                          handleChange={() => {}}
                                        />
                                      </>
                                    )}
                                  </Col>
                                  <Col span={6} offset={1}>
                                    {localdoctemp.fileData ? (
                                      <>
                                        <div className='file-details'>
                                          <div className='file-name'>
                                            {localdoctemp.fileData.name}
                                          </div>
                                          <img
                                            className='remove-file'
                                            onClick={() => {
                                              removeDoc(
                                                key,
                                                kycdoc,
                                                localdoctemp?.documentSubType
                                              );
                                            }}
                                            src={imgURL['cross-circle']}
                                            alt='close'
                                          />
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <Upload
                                          beforeUpload={() => {
                                            return false;
                                          }}
                                          multiple={false}
                                          accept='image/png, image/jpeg, pdf'
                                          onChange={async ({ file }) => {
                                            const fileData =
                                              await convertFileToBase64(file);
                                            updateDocName(
                                              key,
                                              kycdoc,
                                              'file',
                                              localdoctemp?.documentSubType,
                                              fileData
                                            );
                                          }}
                                        >
                                          <Button
                                            enable={true}
                                            label='Upload'
                                            btnStyleClass='secondary-button upload-action'
                                          />
                                        </Upload>
                                      </>
                                    )}
                                  </Col>
                                </Row>
                              )}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                );
              })}
          </div>
          <ProfileFooter
            nextPage={nextPage}
            prevPage={prevPage}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            saveAction={callFormSubmit}
            submitAction={submitForm2Action}
            enableSave={enableSave}
            enableSaveAndNext={enableSaveNext}
            submitLabel='Submit'
          />
          {isErrorModal && (
            <ErrorModal
              description={errDesc}
              handleClose={() => {
                kycFormSubmitClear();
                setIsErrorModal(false);
              }}
            />
          )}
        </>
      )}
    </form>
  );
};

const ErrorModal = (props: any): JSX.Element => {
  return (
    <React.Fragment>
      <Modal
        className={'support-model'}
        backButtonEnable={false}
        onBackdropClick={() => props.handleClose && props.handleClose()}
      >
        <div className='modal-header'>
          <h2 className='support-modal-heading error'>
            <img src={imgURL['alert-red']} />
            Signup Error
          </h2>
          <img
            className='cursor-pointer'
            src={imgURL['cross-circle']}
            alt='Close'
            onClick={() => props.handleClose && props.handleClose()}
          />
        </div>
        <div className='support-modal-body'>
          <div className='description'>{props.description || ''}</div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = ({
  validationReducer,
  completeProfileReducer,
  signupReducer,
  loginReducer,
}) => ({
  validationErrors: validationReducer.validationErrorState.validationErrors,
  uploadDocState: completeProfileReducer?.uploadDocState,
  salesforceState: signupReducer.salesforceState,
  kycSubmitState: completeProfileReducer?.kycSubmitState,
  kycReSubmitState: completeProfileReducer?.kycReSubmitState,
  loginState: loginReducer?.loginState,
});

export default connect(mapStateToProps, {
  verifyKYCAction,
  salesforceAuth,
  clearSalesforceAuth,
  kycFormSubmitAction,
  kycFormReSubmitAction,
  updateAccountAction,
  kycFormSubmitClear
})(UploadDocuments);
